import { Capacitor } from '@capacitor/core';
import { joinBasePath, resolveBasePath, scopedCacheName, scopedStorageKey } from './runtime-paths.mjs';

const isNative = Capacitor.isNativePlatform();
const configuredAppUrl = String(import.meta.env.VITE_PUBLIC_APP_URL || 'https://order.brooklynbowl.ru').replace(/\/$/, '');
const moduleScript = document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.src ?? '';
const browserBasePath = resolveBasePath({
  configuredBasePath: String(import.meta.env.VITE_KIOSK_BASE_PATH || ''),
  scriptUrl: moduleScript,
  pathname: window.location.pathname,
});
const nativeUrl = new URL(configuredAppUrl);
const basePath = isNative ? resolveBasePath({ configuredBasePath: nativeUrl.pathname }) : browserBasePath;
const publicBaseUrl = isNative ? configuredAppUrl : `${window.location.origin}${basePath}`;
const staticBasePath = isNative ? '' : basePath;

export const kioskRuntime = {
  isNative,
  basePath,
  publicBaseUrl,
  apiBase: `${publicBaseUrl}/api/v1`,
  storageKey: (key: string) => scopedStorageKey(basePath, key),
  cacheName: (rootName: string, version: string) => scopedCacheName(basePath, rootName, version),
  publicPath: (path: string) => joinBasePath(staticBasePath, path),
  publicUrl: (path: string) => `${publicBaseUrl}/${path.replace(/^\/+/, '')}`,
};

export const runtimeAssetPath = (value: string) => (
  value.startsWith('/images/') || value.startsWith('/icons/') ? kioskRuntime.publicPath(value) : value
);
